import React from "react";
import { Box, Typography, Button } from "@mui/material";

export default function ThankYou() {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        background: "#ffffff",
      }}
    >
      <Typography variant="h3" sx={{ mb: 2, fontWeight: 700, color: "#455354" }}>
        Thank You
      </Typography>

      <Typography sx={{ mb: 4, color: "#555", fontSize: "1.2rem" }}>
        We have received your details.
      </Typography>

      <Button
        variant="contained"
        onClick={() => window.location.href = "/main/generate-reports"}
        sx={{
          background: "#455354",
          color: "white",
          px: 4,
          py: 1.5,
          borderRadius: "8px",
          fontWeight: 600,
          "&:hover": { background: "#354142" },
        }}
      >
        Back to Home
      </Button>
    </Box>
  );
}
